import ShowChartIcon from '@mui/icons-material/ShowChart'
import BaseWidgetProvider from '../base/BaseWidgetProvider'
import GraphicWidget from './GraphicWidget'
import React from 'react'

class GraphicWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'GraphicWidgetProvider'

  getName = () => ''

  getIcon = () => ShowChartIcon

  createWidget = (props) => <GraphicWidget {...props} />

  createPreviewWidget = (props) => <GraphicWidget {...props} />

  size = { defaultW: 4, defaultH: 3, minW: 3, minH: 2, maxW: 10, maxH: 8 }

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight, this.size), availableWithoutDevice: true, hideHeader: false }
  }

  getConfigurationInfo = () => {
    return [
      {
        key: 'variableName',
        label: 'Variable Name',
        type: 'text',
        defaultValue: ''
      },
      {
        key: 'title',
        label: 'Title',
        type: 'text',
        defaultValue: 'Speed / Time'
      },
      {
        key: 'min',
        label: 'Min Value',
        type: 'number',
        defaultValue: 0
      },
      {
        key: 'max',
        label: 'Max Value',
        type: 'number',
        defaultValue: 60
      },
      {
        key: 'intervalMinutes',
        label: 'Interval (min)',
        type: 'number',
        defaultValue: 30,
        inputProps: { min: 1 }
      },
      {
        key: 'time',
        label: 'Time range',
        type: 'timeRange',
        defaultValue: '24:00:00'
      },
      {
        key: 'startTime',
        label: 'From',
        type: 'timeRange',
        defaultValue: null
      },
      {
        key: 'endTime',
        label: 'To',
        type: 'timeRange',
        defaultValue: null
      }
    ]
  }
}

export default GraphicWidgetProvider
